import axiosInstance from "../lib/axios.instance";
import {
  Chat,
  CreateChatPayload,
  UpdateChatPayload,
  ResearchChatData,
  SendMessagePayload,
  SendMessageResponse,
} from "../types/research.types";

export const researchService = {
  // Get all chats for the current user (optionally filtered by document)
  getChats: async (documentId?: string): Promise<Chat[]> => {
    const params = documentId != null ? { document_id: documentId } : {};
    const response = await axiosInstance.get<Chat[]>("/openai-research/list_chats", { params });
    return response.data;
  },

  // Get a single chat by ID with messages
  getChat: async (chatId: string): Promise<ResearchChatData> => {
    const response = await axiosInstance.post<ResearchChatData>("/openai-research/get_chat", {
      chat_id: chatId,
    });
    return response.data;
  },

  // Create a new chat
  createChat: async (payload: CreateChatPayload): Promise<Chat> => {
    const response = await axiosInstance.post<Chat>("/openai-research/create_chat", payload);
    return response.data;
  },

  // Update chat title (rename chat)
  updateChat: async (payload: UpdateChatPayload): Promise<Chat> => {
    const response = await axiosInstance.put<Chat>("/openai-research/rename_chat", payload);
    return response.data;
  },

  // Delete a chat
  deleteChat: async (chatId: string): Promise<void> => {
    await axiosInstance.delete("/openai-research/delete_chat", {
      data: {
        chat_id: chatId,
      },
    });
  },

  // Send a message in a research chat
  sendMessage: async (payload: SendMessagePayload): Promise<SendMessageResponse> => {
    const response = await axiosInstance.post<SendMessageResponse>("/openai-research/", payload);
    return response.data;
  },
};
